import { render } from "./examine_show.vue?vue&type=template&id=b83885a0&scoped=true"
import script from "./examine_show.vue?vue&type=script&lang=js"
export * from "./examine_show.vue?vue&type=script&lang=js"

import "./examine_show.vue?vue&type=style&index=0&id=b83885a0&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b83885a0"]])

export default __exports__